<!--
 * @Author: error: git config user.name && git config user.email & please set dead value or install git
 * @Date: 2022-08-24 16:57:25
 * @LastEditors: error: git config user.name && git config user.email & please set dead value or install git
 * @LastEditTime: 2022-09-08 12:20:53
 * @FilePath: \ioc_base\src\modules\elePatrolReport\components\patrolDetail.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="dialog-app-panel" :class="showPanel ? 'dialog-show' : ''">
    <appPanel
      :width="700"
      class="app-panel"
      :isExpand="showPanel"
      @cancel="handleClosePanel"
      title="巡更任务详情"
    >
      <!-- 基本信息 -->
      <div style="height: 100%">
        <el-scrollbar style="height: 100%">
          <div class="panel-info">
            <div>
              <div class="panel-title">
                <span class="flagStyle"></span>
                基本信息
              </div>
              <el-form
                ref="panel-form"
                :model="infoForm"
                :label-width="labelWidth"
                label-suffix=" ："
              >
                <el-col :span="24">
                  <el-form-item label="任务单号"
                    >{{ infoForm.patrolTaskCode }}
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="任务名称">{{ infoForm.taskName }}</el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="任务状态">{{
                    statusObj[infoForm.taskStatus]
                  }}</el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="计划开始时间">
                    {{ infoForm.taskStartTime }}
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="计划结束时间">{{
                    infoForm.taskEndTime
                  }}</el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="实际开始时间">{{
                    timeFormatter(infoForm.realStartTime)
                  }}</el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="实际结束时间">{{
                    timeFormatter(infoForm.realEndTime)
                  }}</el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="是否发现异常">{{
                    isError(tableData)
                  }}</el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item label="任务执行人员">{{
                    infoForm.executorNames
                  }}</el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item label="任务巡更进度">
                    {{
                      "应巡更点位" +
                      infoForm.totalPoint +
                      ",已巡更点位" +
                      infoForm.clockPointNum +
                      ",剩余巡更点位" +
                      (infoForm.totalPoint - infoForm.clockPointNum)
                    }}</el-form-item
                  >
                </el-col>
              </el-form>
            </div>
            <!-- 异常记录 -->
            <div>
              <div class="panel-title">
                <span class="flagStyle"></span>
                异常列表
              </div>
              <el-table :data="tableData" style="width: 100%">
                <el-table-column type="index" label="序号" width="50"> </el-table-column>
                <el-table-column prop="alarmName" show-overflow-tooltip label="异常名称">
                </el-table-column>
                <el-table-column
                  prop="reportPersonName"
                  show-overflow-tooltip
                  label="上报人"
                >
                </el-table-column>
                <el-table-column prop="alarmTime" show-overflow-tooltip label="上报时间">
                </el-table-column>
                <el-table-column
                  prop="alarmState"
                  show-overflow-tooltip
                  label="异常处理"
                  :formatter="stateFormatter"
                >
                </el-table-column>
                <el-table-column label="操作" width="80">
                  <template v-slot="scope">
                    <el-tooltip
                      effect="dark"
                      content="查看"
                      placement="top-start"
                      :visible-arrow="false"
                    >
                      <el-button
                        type="text"
                        icon="el-icon-view"
                        @click="handleOpenPanelError(scope.row)"
                      >
                      </el-button>
                    </el-tooltip>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <!-- 打卡记录 -->
            <div>
              <div class="panel-title">
                <span class="flagStyle"></span>
                打卡记录
              </div>
              <el-table :data="reportData" style="width: 100%">
                <el-table-column type="index" label="序号" width="50"> </el-table-column>
                <el-table-column
                  prop="pointName"
                  show-overflow-tooltip
                  label="巡更点名称"
                >
                </el-table-column>
                <el-table-column prop="clockPerson" show-overflow-tooltip label="打卡人">
                </el-table-column>
                <el-table-column
                  prop="punchType"
                  show-overflow-tooltip
                  label="打卡方式"
                  :formatter="punchTypeFormatter"
                >
                </el-table-column>
                <el-table-column prop="clockTime" align="center" label="打卡图片">
                  <template slot-scope="scope">
                    <el-button
                      type="text"
                      v-if="scope.row.images"
                      @click="handleShowImg(scope.row.images)"
                      >查看</el-button
                    >
                    <div v-else>无</div>
                  </template>
                </el-table-column>
                <el-table-column prop="clockTime" align="center" label="打卡视频">
                  <template slot-scope="scope">
                    <el-button
                      type="text"
                      v-if="scope.row.videos"
                      @click="handleShowVideo(scope.row.videos)"
                      >查看</el-button
                    >
                    <div v-else>无</div>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="clockTime"
                  show-overflow-tooltip
                  label="打卡时间"
                  :formatter="clocktimeFormatter"
                >
                </el-table-column>
              </el-table>
            </div>
          </div>
        </el-scrollbar>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClosePanel" type="info">关闭</el-button>
      </span>
    </appPanel>

    <app-panel
      :width="700"
      class="app-panel"
      :isExpand="showPanelError"
      @cancel="handleClosePanelError"
      title="巡更异常详情"
    >
      <div class="base-table">
        <div class="base-table_row">
          <div class="col-content">
            <div class="col-label">上报时间：</div>
            <div class="col-value">
              {{ infoFormError.reportTime || "无" }}
            </div>
          </div>
          <div class="col-content">
            <div class="col-label">上报人：</div>
            <div class="col-value">
              {{ infoFormError.reportPersonName || "无" }}
            </div>
          </div>
        </div>
        <div class="base-table_row">
          <div class="col-content">
            <div class="col-label">事件编号：</div>
            <div class="col-value">{{ infoFormError.alarmId || "无" }}</div>
          </div>
        </div>
        <div class="base-table_row">
          <div class="col-content">
            <div class="col-label">问题描述：</div>
            <div class="col-value">
              {{ infoFormError.desc || "无" }}
            </div>
          </div>
        </div>
        <div class="base-table_row">
          <div class="col-content">
            <div class="col-label">现场图片：</div>
            <div class="ioc-detail__image" style="width: 90%; margin: 10px 0">
              <template v-if="infoFormError.picUrl">
                <el-carousel style="height: 180px; overflow: hidden">
                  <el-carousel-item
                    v-for="item in (infoFormError.picUrl || '无').split(',')"
                    :key="item"
                  >
                    <img
                      class="lookPhoto"
                      :src="getImgPath(item)"
                      style="width: 200px; height: 160px"
                      alt
                      @click="showViewer"
                      onerror="this.src='/images/theme/newDark/default.png'"
                    />
                  </el-carousel-item>
                </el-carousel>
              </template>
              <template v-else>
                <img
                  style="height: 120px; width: 50%"
                  :src="`/images/theme/newDark/default.png`"
                />
              </template>
            </div>
          </div>
        </div>
        <div class="base-table_row">
          <div class="col-content">
            <div class="col-label">录像回放：</div>
            <div class="col-value">
              <video
                v-if="infoFormError.videoUrl"
                class="file-comp"
                :src="$utils.Bus.imgPath(infoFormError.videoUrl)"
              ></video>
              <!-- <video preload="none" id="videoDom" controls="controls">
                您的浏览器不支持 video 标签。
              </video> -->
            </div>
          </div>
        </div>
      </div>
      <div slot="footer">
        <el-button @click="close" type="info" class="buttonDark">关闭</el-button>
      </div>
    </app-panel>

    <app-panel
      :width="700"
      class="app-panel"
      :isExpand="showPanelEvent"
      @cancel="handleClosePanelEvent"
      title="事件详情"
    >
      <div style="height: 100%">
        <el-scrollbar style="height: 100%">
          <div class="panel-info">
            <div>
              <div class="panel-title">
                <span class="flagStyle"></span>
                基本信息
              </div>
              <el-form ref="panel-form" :model="infoFormEvent" label-width="90px">
                <el-row>
                  <img
                    style="width: 150px; height: 150px; flex: 1; padding: 8px 0px"
                    src="@src/common/assets/images/homeMenu/menubg.png"
                    alt=""
                  />
                  <div style="flex: 2; padding: 10px 0px">
                    <el-col :span="12">
                      <el-form-item label="事件编号"
                        >{{ infoFormEvent.patrolTaskCode }}
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="事件名称">{{
                        infoFormEvent.taskName
                      }}</el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="事件来源">{{
                        infoFormEvent.taskName
                      }}</el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="上报人">{{
                        infoFormEvent.taskName
                      }}</el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="上报时间">{{
                        infoFormEvent.taskName
                      }}</el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="事件级别">{{
                        infoFormEvent.taskName
                      }}</el-form-item>
                    </el-col>
                  </div>
                </el-row>
                <el-col :span="8">
                  <el-form-item label="事件分类"
                    >{{ infoFormEvent.patrolTaskCode }}
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="事件状态">{{
                    infoFormEvent.taskName
                  }}</el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="事件确认"
                    >{{ infoFormEvent.taskStatus }}
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="处理人">
                    {{ infoFormEvent.taskStartTime }}
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="事件位置">
                    {{ infoFormEvent.taskStartTime }}
                  </el-form-item>
                </el-col>
              </el-form>
            </div>
            <div>
              <div class="panel-title">
                <span class="flagStyle"></span>
                事件工单
              </div>
              <div class="work-order">
                <el-timeline>
                  <!-- workOrderList -->
                  <el-timeline-item>
                    <div class="work-order-list">
                      <div class="list-title">工单派发</div>
                      <div class="list-content">
                        <span class="content">工单号：xxx</span>
                        <span>工单标题：xxx</span>
                      </div>
                      <div class="list-content">
                        <span class="content">派发人：xxx</span>
                        <span>派发时间：xxx</span>
                      </div>
                      <div class="list-content">
                        <span class="content">责任人：xxx</span>
                      </div>
                      <div class="list-content">
                        <span class="content">派发说明：xxx</span>
                      </div>
                    </div>
                  </el-timeline-item>
                  <el-timeline-item>
                    <div class="work-order-list">
                      <div class="list-title">执行反馈</div>
                      <div class="list-content">
                        <span class="content">反馈人：xxx</span>
                        <span>反馈时间：xxx</span>
                      </div>
                      <div class="list-content">
                        <span>反馈内容：xxx</span>
                      </div>
                      <div class="list-content">图片</div>
                    </div>
                  </el-timeline-item>
                  <el-timeline-item>
                    <div class="work-order-list">
                      <div class="list-title">工单关闭</div>
                      <div class="list-content">
                        <span class="content">关闭人：xxx</span>
                        <span>关闭时间：xxx</span>
                      </div>
                      <div class="list-content">
                        <span>反馈说明：xxx</span>
                      </div>
                    </div>
                  </el-timeline-item>
                </el-timeline>
              </div>
            </div>
          </div>
        </el-scrollbar>
      </div>
    </app-panel>
    <viewer @inited="inited" :images="viewerPhotos" class="viewer" ref="viewer">
      <img v-for="src in viewerPhotos" :src="src" :key="src" />
    </viewer>
    <el-dialog title="视频播放" append-to-body :visible.sync="showVideo" width="700px">
      <video
        class="file-comp"
        controls="controls"
        style="width: 100%; height: 400px"
        :src="$utils.Bus.imgPath(pintsVideo)"
      ></video>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showVideo = false">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { Dic } from "$utils";
import { api } from "../api";
import { Dates, Bus } from "$utils";
import appPanel from "@src/components/business/app-panel/index";
export default {
  components: { appPanel },
  data() {
    return {
      pintsVideo: "",
      showVideo: false,
      viewerPhotos: [],
      viewerInstance: null,
      showPanel: false,
      showPanelError: false,
      showPanelEvent: false,
      infoForm: {},
      infoFormError: {},
      infoFormEvent: {},
      labelWidth: "115px",
      statusObj: {
        1: "待巡逻",
        2: "巡逻中",
        3: "已完成",
        4: "已超时",
      },
      tableData: [],
      reportData: [],
      workOrderList: [
        {
          content: "活动按期开始",
          timestamp: "2018-04-15",
        },
        {
          content: "通过审核",
          timestamp: "2018-04-13",
        },
        {
          content: "创建成功",
          timestamp: "2018-04-11",
        },
      ],
    };
  },
  computed: {},
  mounted() {},
  methods: {
    handleShowVideo(video) {
      if (this.pintsVideo) {
        this.pintsVideo = "";
      }
      this.$nextTick(() => {
        this.pintsVideo = video;
        this.showVideo = true;
      });
    },
    handleShowImg(img) {
      let imgList = img.split(",").map((el) => {
        return this.getImgPath(el);
      });
      this.$app.AppInstance.handleShowViewer(imgList);
    },
    showViewer(e) {
      // this.viewerPhotos = [e.target.src];
      this.viewerPhotos = [
        e.target.src.indexOf("default/default.png") == -1
          ? e.target.src + "&sourceFileFlag=1"
          : e.target.src,
      ];
      this.viewerInstance.show();
    },
    // 1.图片放大器
    inited(viewer) {
      this.viewerInstance = viewer;
    },
    // 查看大图
    pictureShow(val) {
      this.viewerPhotos = [val];
      this.viewerInstance.show();
    },
    getImgPath(item = "") {
      return item ? Bus.imgPath(item) : "";
    },
    close() {
      this.showPanelError = false;
      this.infoFormError = [];
    },
    isError(row, column) {
      if (row != null && row.length > 0) {
        return "是";
      } else {
        return "否";
      }
    },
    punchTypeFormatter(row, column) {
      if ("1" == row.punchType) {
        return "二维码";
      } else {
        return "GPS";
      }
    },
    stateFormatter(row, column) {
      return Dic.findByValue("SENU068", Number(row.alarmState));
    },
    clocktimeFormatter(row, column) {
      return row.clockTime
        ? Dates.dayjs(row.clockTime).format("YYYY-MM-DD HH:mm:ss")
        : "";
    },
    queryRecDetail(patrolTaskCode) {
      const self = this;
      self
        .$fetch(api.patrolTask.queryPatrolTaskDetail, { patrolTaskCode: patrolTaskCode })
        .then((res) => {
          if (res.returnObj) {
            this.tableData = res.returnObj.alarmList;
            this.reportData = res.returnObj.taskLocations;
            // let recomStartTime = res.returnObj.taskStartTime ? Dates.format(new Date(res.returnObj.taskStartTime), 'yyyy-MM-dd HH:mm:ss') : "";
            // let recomEndTime = res.returnObj.taskEndTime ? Dates.format(new Date(res.returnObj.taskEndTime), 'yyyy-MM-dd HH:mm:ss') : "";
            // let realStartTime = res.returnObj.realStartTime ? Dates.format(new Date(res.returnObj.realStartTime), 'yyyy-MM-dd HH:mm:ss') : "";
            // let realEndTime = res.returnObj.realEndTime ? Dates.format(new Date(res.returnObj.realEndTime), 'yyyy-MM-dd HH:mm:ss') : "";
            // this.taskTitle = {
            //   taskName: res.returnObj.taskName,
            //   personInCharge: res.returnObj.reportPerson,
            //   taskStatus: this.taskStatusType[res.returnObj.taskStatus],
            //   recomTime: recomStartTime + " 至 " + recomEndTime,
            //   realTime: realStartTime + " 至 " + realEndTime,
            //   executorNames: res.returnObj.executorNames,
            //   securityWorkGroupNames: res.returnObj.securityWorkGroupNames,
            //   clockPointNum: res.returnObj.taskLocations.length,
            //   unClockPointNum: res.returnObj.uncompleteTaskLocations.length,
            //   planReport: res.returnObj.planReport && res.returnObj.planReport.split('</br>')
            // }
          }
        });
    },
    timeFormatter(value) {
      return value ? Dates.dayjs(value).format("YYYY-MM-DD HH:mm:ss") : "";
    },
    handleClosePanel() {
      this.showPanel = false;
      this.tableData = [];
      this.reportData = [];
    },
    handleClosePanelError() {
      this.showPanelError = false;
    },
    handleClosePanelEvent() {
      this.showPanelEvent = false;
    },
    handleOpenPanel(info) {
      this.queryRecDetail(info.patrolTaskCode);
      this.infoForm = { ...info };
      this.showPanel = true;
    },
    handleOpenPanelError(info) {
      let params = {
        alarmId: info.alarmId,
      };
      this.$fetch(api.patrolTask.queryAlarmDetail, params).then((response) => {
        if (response.success) {
          this.infoFormError = response.returnObj;
          this.showPanelError = true;
        } else {
          this.$message.error(response.msgContent || "获取巡更异常详情失败");
          this.showPanelError = false;
        }
      });
    },
    handleOpenPanelEvent(info) {
      this.infoFormEvent = { ...info };
      this.showPanelEvent = true;
    },
  },
};
</script>
<style lang="scss" scoped>
.panel-info {
  display: flex;
  flex-direction: column;

  .panel-title {
    display: flex;
    margin-bottom: 10px;
    margin-top: 10px;

    .flagStyle {
      margin-right: 10px;
    }
  }

  .work-order {
    padding-top: 10px;
    padding-left: 20px;

    &-list {
      color: gray;
    }

    .list-title {
      color: #fff;
    }

    .list-content {
      margin: 10px 10px 10px 0;

      .content {
        margin-right: 30px;
      }
    }
  }
}
.base-table_row {
  display: flex;
  padding-bottom: 25px;

  // flex-direction: column;
  .col-content {
    flex: 1;
    display: inline-flex;

    .col-label {
      width: 100px;
      // background: #4b5566;
      text-align: center;
      padding: 2px 10px;
      border-radius: 3px;
    }

    .col-value {
      width: 300px;
      // background: #4b5566;
      text-align: left;
      padding: 2px 10px;
      border-radius: 3px;

      img,
      video {
        width: 150px;
        height: 150px;
        border-radius: 5px;
      }
    }
  }
}
</style>
